import React from 'react'
import "./ringLoader.css"
function RingLoader() {
  return (
    <div class="ring-loader"></div>
  )
}

export default RingLoader